/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
import React from 'react';
import { AuthProvider } from './src/context/Authentification';
import { NumberTriesProvider } from './src/context/NumberTriesProvider';

export const wrapRootElement = ({ element }) => (
  
  <AuthProvider>
      <NumberTriesProvider>
        {element}
      </NumberTriesProvider>
  </AuthProvider>
)